import { ComponentQueryLoader } from '../../shared/component-query-loader';
import { About } from './about';

interface AboutContainerProps {}

export const AboutContainer: React.FC<AboutContainerProps> = (props) => {
  // Add this handling when you have a query to fetch data from the server
  // const { data: data, loading: loading, error: error } = useQuery(WelcomeContainerFeeAmountDocument);
  const aboutPageData = {
    title: 'About',
    description: `
      <p>Hallo, and welcome to my site. My name is Ikeem Wilson, and I am a United States citizen who is currently
      looking for work in the Netherlands. I am a software developer who is passionate about building software
      that is scalable, maintainable, and testable. I love learning new technologies and applying them to solve
      real-world problems.</p>
      <p><b>Why the Netherlands?</b> My wife and I visited the Netherlands in 2014, and we fell in love with the
      country. We love the people, the culture, and the way of life. We have been back to visit twice since then,
      and we have decided that we would like to live there. I am currently learning Dutch, and I have been
      looking for a job there since September of 2022.</p>
      <p>Thank you for reading, and I hope you have a wonderful day. Tot ziens!</p>`,
    keywords: ['about', 'page'],
    image:{
      src: 'https://interactivecveast2.blob.core.windows.net/photos/Me.jpg',
      fallback: 'https://interactivecveast2.blob.core.windows.net/photos/error.png'
    },
    contactInfo: [
      {
        key: 'cell',
        icon: 'phone',
        value: '+1 (612) 432-0424'
      },
      {
        key: 'whatsapp',
        icon: 'whatsapp',
        value: '+1 (612) 432-0424'
      },
      {
        key: 'email',
        icon: 'mail',
        value: 'ikeem_wilson@yahoo.com'
      },
      {
        key: 'linkedin',
        icon: 'linkedin',
        value: 'https://www.linkedin.com/in/ike-wilson/'
      }
    ]
  }

  return (
    <ComponentQueryLoader 
      hasData={true}
      hasDataComponent={<About aboutPageData={aboutPageData}/>}
      noDataComponent={<>No component</>}
    />
  )
}